export const LOGO_URL = "https://picsum.photos/seed/logo/200/50";

export const LEADERSHIP = [
  {
    name: "Anand A",
    role: "Business & Operations Head — India",
    region: "India",
    image: "/profiles/Anand.png",
    bio: "With a strong background in business development and client management, Anand leads AmagicTech with a vision of delivering client-focused, result-driven solutions.",
    long:
      "Over a decade of experience in operations, delivery, and client strategy across SMB and enterprise segments in India. He oversees cross-functional execution, process optimization, and revenue growth — having led multi-year digital transformation programs and scaled service delivery teams with data-driven operations.",
    email: "anand@amagictechsolutions.com",
    linkedin: "https://www.linkedin.com/in/anand-a/",
  },
  {
    name: "Sandhip Ravindran",
    role: "Business & Operations Head — GCC",
    region: "GCC",
    image: "/profiles/sandhip.png",
    bio: "Driving business growth and operational excellence across GCC markets with a strong focus on client success and regional partnerships.",
    long:
      "Sandhip leads our GCC operations with a focus on market expansion, partner enablement, and enterprise engagement. He has driven successful entries into new verticals, strengthened strategic alliances, and improved regional delivery — spanning B2B relationships, large-deal pursuits, and governance tailored to the GCC.",
    email: "sandhipr@amagictechsolutions.com",
    linkedin: "https://www.linkedin.com/in/sandhip-ravindran/",
  },
  {
    name: "Thomas Raju",
    role: "Product Manager",
    region: "India",
    image: "/profiles/Thomas.png",
    bio: "Leading product strategy and execution, transforming business vision into customer-centric digital products.",
    long:
      "Oversees end-to-end product lifecycle management across web, mobile, and AI solutions. Thomas collaborates with design, engineering, and clients to define roadmaps, optimize user journeys, and ensure high-impact product delivery.",
    email: "thomas@amagictechsolutions.com",
    linkedin: "https://www.linkedin.com/in/thomas-raju-6abb3559/",
  },
  {
    name: "Vaisagh TM",
    role: "Admin & HR Manager",
    region: "India",
    image: "/profiles/vaisagh.png",
    bio: "Vaisagh oversees administration and HR at AmagicTech, ensuring people, culture, and processes work seamlessly together.",
    long:
      "Hands-on experience in HR operations, employee engagement, and office administration. He focuses on building a supportive workplace, streamlining internal processes, and enabling teams to perform at their best across locations.",
    email: "vaisaghtm@amagictechsolutions.com",
    linkedin: "https://www.linkedin.com/in/vaisagh-t-m-1731709b/",
  },
];


export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/#products", label: "Products", testid: "nav-products" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/portfolio", label: "Portfolio", testid: "nav-portfolio" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/blog", label: "Blog", testid: "nav-blog" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const SERVICES = [
  {
    id: "web",
    code: "01",
    title: "Web Applications",
    short: "React, Node.js, and modern APIs power customizable platforms tailored to your workflows.",
    detail:
      "Composable storefronts, internal platforms, and SaaS products engineered with React, Next.js, FastAPI/Node, and cloud-native ops. We ship maintainable systems with automated tests and observability.",
    icon: "Globe",
    bullets: [
      "Composable e-commerce & marketplaces",
      "Secure internal portals & dashboards",
      "Modern APIs (REST / GraphQL)",
      "Performance & SEO engineering",
    ],
  },
  {
    id: "mobile",
    code: "02",
    title: "Mobile Experiences",
    short: "Native iOS, Android, and cross-platform apps built with React Native and Flutter.",
    detail:
      "Consumer-grade mobile products from prototype to App Store. Pixel-perfect UI, offline-first sync, push notifications, and analytics that drive retention.",
    icon: "Smartphone",
    bullets: [
      "React Native & Flutter",
      "Native iOS / Android modules",
      "Offline-first architecture",
      "App Store / Play Store launch",
    ],
  },
  {
    id: "ai",
    code: "03",
    title: "AI & Automation",
    short: "Machine learning, NLP, and predictive analytics streamline operations and unlock new insights.",
    detail:
      "From custom GPT copilots to vision pipelines and forecasting models. We integrate AI where it creates measurable business outcomes — not just demos.",
    icon: "BrainCircuit",
    bullets: [
      "LLM-powered copilots & agents",
      "Predictive analytics",
      "Document understanding (OCR / NLP)",
      "Workflow automation",
    ],
  },
  {
    id: "marketing",
    code: "04",
    title: "Digital Marketing",
    short: "SEO, content, and paid media campaigns that attract, convert, and retain your best customers.",
    detail:
      "Performance marketing built on engineering rigor. We instrument funnels, run measured campaigns, and feed insights back into product.",
    icon: "LineChart",
    bullets: [
      "Technical SEO & content",
      "Paid search & social",
      "Conversion-rate optimization",
      "Analytics & attribution",
    ],
  },
  {
    id: "it",
    code: "05",
    title: "IT Solutions",
    short: "Custom ERP, CRM, and invoicing systems that streamline operations and unify data.",
    detail:
      "Bespoke business systems that replace spreadsheets and disjointed SaaS. ERP, CRM, and finance tooling integrated with your existing stack.",
    icon: "Server",
    bullets: [
      "Custom ERP solutions",
      "CRM & customer platforms",
      "Automated invoicing",
      "Integrations & migrations",
    ],
  }
];

export const STATS = [
  { value: "28+", label: "Projects Delivered" },
  { value: "50+", label: "Happy Clients" },
  { value: "5+", label: "Years Experience" },
  { value: "4", label: "Continents Served" },
];

export const WHY_US = [
  {
    title: "Cross-Industry Expertise",
    body: "Experience across e-commerce, fintech, manufacturing, construction, and services.",
  },
  {
    title: "Scalable & Future-Ready",
    body: "Solutions built to grow with your business using modern, maintainable stacks.",
  },
  {
    title: "UX-Focused Design",
    body: "User-centered design that enhances engagement and drives conversions.",
  },
  {
    title: "End-to-End Partnership",
    body: "From concept to deployment and ongoing maintenance — your complete tech partner.",
  },
];

export const PRODUCTS = [
  {
    id: "tripywiz",
    name: "TripyWiz",
    category: "Travel SaaS",
    tagline: "AI itinerary & quotation platform for travel agencies.",
    description:
      "Build, share, and manage professional travel itineraries with a drag-and-drop builder. Get instant client approvals with digital signatures and close deals faster.",
    image: "/products/tripywiz.png",
    url: "https://tripywiz.com",
    stats: [
      { value: "10k+", label: "Itineraries" },
      { value: "2.5x", label: "Deal Speed" },
      { value: "99%", label: "Approve Rate" },
    ],
    features: ["AI-powered itinerary generation", "Digital approvals & e-signatures", "Smart pricing & quotations"],
  },
  {
    id: "aidni",
    name: "Aidni",
    category: "AI Support",
    tagline: "Turn your docs into an AI chatbot in minutes.",
    description:
      "Instantly answer customer questions with a chatbot trained on your data. Upload content, customize the brand, and embed anywhere with a single line of code.",
    image: "/products/aidni.png",
    url: "https://aidni.io",
    stats: [
      { value: "GPT-4o", label: "Powered by" },
      { value: "2 min", label: "Setup time" },
      { value: "24/7", label: "Auto support" },
    ],
    features: ["Train on PDFs, docs & URLs", "Fully customizable widget", "One-line embed + analytics"],
  },
  {
    id: "kadai",
    name: "Kadai",
    category: "AI Commerce",
    tagline: "Your AI-powered shopping companion.",
    description:
      "An e-commerce platform with a conversational AI assistant that finds exactly what shoppers need — no more endless scrolling. Multi-currency, multi-region, enterprise-grade security.",
    image: "/products/kadai.png",
    url: "https://kadai.amagic.site",
    stats: [
      { value: "700+", label: "Products" },
      { value: "6+", label: "Payment modes" },
    ],
    features: ["Conversational AI shopping", "Best Match / Budget / Premium picks", "Multi-currency checkout"],
  },
];

const A = (p) => {
  // amagictechsolutions.com/assets/* is currently returning 404 HTML pages.
  // Using picsum to generate consistent placeholder images based on the filename.
  const seed = p.replace(/[^a-zA-Z0-9]/g, '');
  return `https://picsum.photos/seed/${seed}/800/600`;
};

export const CATEGORIES = [
  "All",
  "Web Application",
  "Web Development",
  "Mobile Development",
  "IT Solutions",
];

export const PROJECTS = [
  {
    title: "Dribblo - Football Fan App",
    category: "Mobile Development",
    client: "Sports & Entertainment",
    image: "/mobile/dribblo.png",
    link: "https://play.google.com/store/apps/details?id=com.dribblo.app",
    description:
      "A feature-rich mobile app built for football enthusiasts — live scores, match highlights, team stats, player tracking, and community discussions all in one place.",
  },
  {
    title: "Xpenso - Expense Tracking App",
    category: "Mobile Development",
    client: "Financial Tech Startup",
    image: "/mobile/xpenso.png",
    link: "https://play.google.com/store/apps/details?id=com.amagictech.xpenso",
    description:
      "A comprehensive mobile expense tracker with budget management, spending analytics, and transaction categorization features.",
  },
   {
    title: "EasyNotes - Note Taking App",
    category: "Mobile Development",
    client: "General Purpose",
    image: "/mobile/easynotes.png",
    link: "https://play.google.com/store/apps/details?id=app.amagic.notes.eazynotes",
    description:
      "A comprehensive mobile note-taking app with a simple, intuitive interface and powerful features.",
  },
  {
    title: "Gym Assist - Fitness App",
    category: "Mobile Development",
    client: "General Purpose",
    image: "/mobile/gymassist.png",
    link: "https://play.google.com/store/apps/details?id=com.gymassist.app",
    description:
      "A comprehensive fitness app with workout tracking, progress monitoring, and personalized fitness plans.",
  },
  {
    title: "SF Store E-Commerce Platform",
    category: "Web Application",
    client: "Fashion Retailer",
    image: "/websites/sfstore_homepage.png",
    link: "https://sfstore.in/",
    description:
      "E-commerce store built on Kadai — AmagicTech's own AI-powered commerce platform. Features a conversational AI shopping assistant, smart product recommendations, secure payments, and a fast, mobile-first storefront.",
  },
  {
    title: "ShopMyTrendz E-Commerce",
    category: "Web Application",
    client: "Fashion Retailer",
    image: "/websites/shopmytrendz_homepage.png",
    link: "https://shopmytrendz.com/",
    description:
      "Modern e-commerce platform with catalog management, secure payments, and personalized shopping experiences.",
  },
  {
    title: "AirMyCart — Parcel Forwarding",
    category: "Web Application",
    client: "E-commerce Enhancement",
    image: "/websites/airmycart_homepage.png",
    link: "https://www.airmycart.com/",
    description:
      "International parcel forwarding with price comparison, deal alerts, and shopping assistance across platforms.",
  },
  {
    title: "Aspire Group Oman",
    category: "Web Development",
    client: "Aspire Group Oman",
    image: "/websites/aspiregroupoman_homepage.png",
    link: "https://aspiregroupoman.com/",
    description: "Corporate website for Aspire Group Oman.",
  },
  {
    title: "Infinity Stones Oman",
    category: "Web Development",
    client: "Infinity Stones",
    image: "/websites/infinitystonesoman_homepage.png",
    link: "https://www.infinitystonesoman.com/",
    description: "Premium natural stones sourced from Oman, presented with precision and architectural elegance.",
  },
  {
    title: "Amman Builders",
    category: "Web Development",
    client: "Builder in Tamilnadu",
    image: "/websites/ammanbuilders_homepage.png",
    link: "https://ammanbuilders.com/",
    description: "A website for a builder in Tamilnadu showcasing projects and capabilities.",
  },
  {
    title: "Gym Website",
    category: "Web Development",
    client: "A gym in Oman",
    image: A("/assets/portfolio/gym.png"),
    link: "#",
    description: "A modern website for a gym in Oman with class schedules and membership info.",
  },
  {
    title: "VDesign HK — Fashion Sourcing",
    category: "Web Development",
    client: "Fashion Sourcing Company",
    image: "/websites/vdesignhk_homepage.png",
    link: "https://vdesignhk.in/",
    description: "Elegant site for a global fashion sourcing company based in Hong Kong and India.",
  },
  {
    title: "Urlified — URL Shortening",
    category: "Web Development",
    client: "Digital Marketing Agency",
    image: A("/assets/21e0f765-d947-48ac-aef3-45c7357426f3.png"),
    link: "https://urlified.com/",
    description: "Modern URL shortener with analytics, QR codes, and custom branded links.",
  },
  {
    title: "Kenaf Coir Corporate",
    category: "Web Development",
    client: "Manufacturing Company",
    image: "/websites/kenafcoir_homepage.png",
    link: "https://kenafcoir.com/",
    description: "Professional corporate website for a coir products manufacturer.",
  },
  {
    title: "Align Technologies",
    category: "Web Development",
    client: "Technology Company",
    image: "/websites/aligntechnologies_homepage.png",
    link: "https://aligntechnologies.in/",
    description: "Dynamic website for an IT solutions provider with services, case studies, and testimonials.",
  },
  {
    title: "VSpec Global — QC Services",
    category: "Web Development",
    client: "Quality Assurance Company",
    image: "/websites/vspec_homepage.png",
    link: "https://vspec.in/",
    description: "Clean website for a global garment quality control and fabric inspection firm.",
  },
  {
    title: "Al-Najad Oil & Gas Services",
    category: "Web Development",
    client: "Al-Najad Oman (Aspire Group)",
    image: "/websites/alnajadoman_homepage.png",
    link: "https://alnajadoman.com/",
    description: "Corporate website for Al-Najad providing Oil & Gas trading, PDO-LCC status support, and rental services across Oman.",
  },
  {
    title: "VRS Supermarket Canada",
    category: "Web Development",
    client: "VRS Supermarket Inc, Edmonton",
    image: "/websites/vrssupermarketinc_homepage.png",
    link: "https://vrssupermarketinc.ca/",
    description: "Modern digital storefront for VRS Supermarket in Edmonton, Canada — showcasing authentic Indian groceries, fresh produce, and organic foods.",
  },
  {
    title: "VR Mini Supermarket",
    category: "Web Development",
    client: "VR Mini Supermarket, Edmonton",
    image: "/websites/vrminisupermarket_homepage.png",
    link: "https://vrminisupermarket.ca/",
    description: "Website for Edmonton-based Indian grocery store featuring fresh produce, authentic spices, lentils, snacks, and daily essentials.",
  },
  {
    title: "ELF Business Solutions",
    category: "Web Development",
    client: "ELF Business Solutions",
    image: "/websites/elfbusiness_homepage.png",
    link: "https://elfbusiness.in/",
    description: "Corporate portal for ELF Business Solutions featuring project management, turnkey manufacturing, training, consulting, and ELF Systems integration.",
  },
  {
    title: "RNK Builders & Contractors",
    category: "Web Development",
    client: "Construction Company",
    image: "/websites/rnkbuilders_homepage.png",
    link: "https://rnkbuilders.in/",
    description: "Sleek site for a construction company — ‘You dream it, we build it!’",
  },
  {
    title: "Shree Sharavana Construction",
    category: "Web Development",
    client: "Construction Company",
    image: "/websites/shreesharavanaconstruction_homepage.png",
    link: "https://shreesharavanaconstruction.com/",
    description: "Responsive website for a residential & commercial construction firm.",
  },
  {
    title: "Then Kailai Parvatham",
    category: "Web Development",
    client: "Charitable & Spiritual Trust",
    image: "/websites/thenkailaiparvatham_homepage.png",
    link: "https://thenkailaiparvatham.com/",
    description: "Website for spiritual and charitable trust featuring daily Annadhanam, yoga meditation camps, and community initiatives.",
  },
  {
    title: "Gurus Industries Portal",
    category: "Web Development",
    client: "Industrial Manufacturer",
    image: A("/assets/1aee29ea-a82d-45c4-b7a1-397818803f8e.png"),
    link: "https://gurusindustries.com/",
    description: "Manufacturing company website with products, capabilities, and certifications.",
  },
  {
    title: "Anand Nivash — Interior Design",
    category: "Web Development",
    client: "Interior Design Studio",
    image: "/websites/anandnivash_homepage.png",
    link: "https://anandnivash.com/",
    description: "Elegant site for interior and exterior design portfolio and services.",
  },
  {
    title: "Enterprise ERP System",
    category: "IT Solutions",
    client: "Manufacturing Company",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1080&q=80",
    link: "#",
    description: "Custom ERP integrating production, inventory, and sales — streamlining ops.",
  },
  {
    title: "Custom CRM Solution",
    category: "IT Solutions",
    client: "Business Services Company",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1080&q=80",
    link: "#",
    description: "Tailored CRM integrating with business processes to streamline client interactions.",
  },
  {
    title: "Automated Invoicing",
    category: "IT Solutions",
    client: "Accounting Firm",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1080&q=80",
    link: "#",
    description: "Invoicing system that reduced billing time by 60% with reminders and reports.",
  },
];

export const BLOG_POSTS = [
  {
    slug: "scaling-composable-commerce",
    title: "Scaling composable commerce without the rebuild fatigue",
    excerpt:
      "Why headless ≠ rewrite. A pragmatic playbook for evolving legacy storefronts into composable architectures one capability at a time.",
    tag: "Engineering",
    date: "Jan 12, 2026",
    read: "8 min",
  },
  {
    slug: "llm-copilots-that-ship",
    title: "LLM copilots that actually ship — beyond the demo",
    excerpt:
      "Lessons from production: retrieval design, eval harnesses, and the unglamorous work that separates a copilot from a chatbot.",
    tag: "AI",
    date: "Jan 02, 2026",
    read: "11 min",
  },
  {
    slug: "react-native-vs-flutter-2026",
    title: "React Native vs Flutter in 2026 — what we ship and why",
    excerpt:
      "After 12 cross-platform launches, here's our decision framework for picking the right runtime for your mobile app.",
    tag: "Mobile",
    date: "Dec 18, 2025",
    read: "9 min",
  },
  {
    slug: "seo-for-engineered-sites",
    title: "Technical SEO for engineered sites — beyond meta tags",
    excerpt:
      "Core Web Vitals, server-side rendering, structured data, and the engineering bets that compound into organic growth.",
    tag: "Marketing",
    date: "Dec 04, 2025",
    read: "7 min",
  },
  {
    slug: "erp-modernization-playbook",
    title: "A playbook for modernizing legacy ERP without big-bang risk",
    excerpt:
      "Strangler-pattern migrations, phased cutovers, and how to keep manufacturing teams shipping while you rebuild.",
    tag: "IT Solutions",
    date: "Nov 21, 2025",
    read: "10 min",
  },
  {
    slug: "design-systems-small-teams",
    title: "Design systems for small product teams — the 80/20 version",
    excerpt:
      "A lightweight design system that small teams can actually maintain — and the tradeoffs we wish we'd made earlier.",
    tag: "Design",
    date: "Nov 06, 2025",
    read: "6 min",
  },
];

export const CONTACT = {
  offices: [
    {
      city: "Coimbatore, India",
      address: "1373-A, 1st Floor, Jeyashanthi Towers,\nGanapathy, Coimbatore – 641 006,\nTamil Nadu, India.",
      phone: "+91 9843244699",
    },
    {
      city: "Muscat, Oman",
      address: "#25, KG Tower,\nMuscat, Oman.",
      phone: "+968 92679336",
    },
  ],
  email: "info@amagictechsolutions.com",
  hours: {
    weekdays: "Mon – Fri · 9:00 AM – 7:00 PM",
    saturday: "By appointment",
    sunday: "Closed",
  },
  linkedin: "https://www.linkedin.com/in/amagictechsolutions/",
  instagram: "https://www.instagram.com/amagictechsolutions/",
  facebook: "https://www.facebook.com/profile.php?id=61564212020485",
};


export const INDUSTRIES = [
  { name: "E-commerce", icon: "ShoppingBag", note: "Composable stores & marketplaces" },
  { name: "Manufacturing", icon: "Factory", note: "ERP, MES & operations" },
  { name: "Construction", icon: "HardHat", note: "Builder portals & lead engines" },
  { name: "Fintech", icon: "CircleDollarSign", note: "Payments, ledgers & expense" },
  { name: "Real Estate", icon: "Building2", note: "Listings, CRM & sales" },
  { name: "Travel", icon: "Plane", note: "Itineraries, bookings & ops" },
  { name: "Fashion", icon: "Shirt", note: "DTC sites & sourcing" },
  { name: "Quality & QC", icon: "BadgeCheck", note: "Inspection & assurance" },
];

export const PROCESS_STEPS = [
  {
    code: "01",
    title: "Discover",
    body:
      "Stakeholder workshops, audit of existing systems, and a written brief. We surface the real problem worth solving before a line of code is written.",
    deliverable: "Discovery doc · Scope & estimates",
  },
  {
    code: "02",
    title: "Design",
    body:
      "Wireframes, prototypes, and a high-fidelity design system. Iterative reviews with you so the product looks, feels, and behaves as intended.",
    deliverable: "Figma file · Clickable prototype",
  },
  {
    code: "03",
    title: "Build",
    body:
      "Engineering in 1-2 week sprints with demos, automated testing, and continuous integration. You see progress every sprint, not at the end.",
    deliverable: "Working software · Sprint demos",
  },
  {
    code: "04",
    title: "Launch",
    body:
      "Performance hardening, load testing, security review, and go-live. We handle the production cut-over and the first 30 days on standby.",
    deliverable: "Production release · Runbook",
  },
  {
    code: "05",
    title: "Iterate",
    body:
      "Post-launch we measure what matters, ship improvements on a retainer, and stay your engineering partner for the long run.",
    deliverable: "Ongoing support · Roadmap",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "AmagicTech rebuilt our entire commerce stack in 14 weeks. Conversion is up 35% and our team finally has dashboards we trust. They feel like an extension of our company, not an outside vendor.",
    author: "Founder",
    role: "ShopMyTrendz",
    project: "E-commerce platform",
  },
  {
    quote:
      "From Muscat to Coimbatore, response times were always same-day. They understood our regulatory context and shipped a website that ranks and converts. Worth every rial.",
    author: "Director",
    role: "Aspire Group Oman",
    project: "Corporate website",
  },
  {
    quote:
      "We came with a half-formed idea and left with a launched SaaS — TripyWiz. 10,000+ itineraries later, AmagicTech still ships features faster than we can scope them.",
    author: "Co-founder",
    role: "TripyWiz",
    project: "Travel SaaS",
  },
  {
    quote:
      "The team at AmagicTech Solutions exceeded our expectations with their digital marketing solutions. Their strategic and creative approach led to noticeable growth in our online engagement. We're thrilled with the results!",
    author: "Mr. Loganathan",
    role: "Managing Director",
    project: "Gurus Industries",
  },
  {
    quote:
      "Partnering with AmagicTech solution has been a game-changer for our digital marketing. Their expertise boosted our online presence and lead generation significantly. The team's responsiveness and tailored strategies exceeded our expectations.",
    author: "Mr. Senthil",
    role: "CEO",
    project: "Mercury Hydro Tech",
  },
  {
    quote:
      "For our company, collaborating with AmagicTech Solutions has been revolutionary. Their specialized digital marketing techniques greatly raised our website's traffic and conversion rates. The group is results-oriented, kind, and professional.",
    author: "Mr. Arul",
    role: "Manager",
    project: "Shree Sai Engineers",
  },
];

export const FAQS = [
  {
    q: "How long does a typical engagement take?",
    a: "Most marketing sites ship in 4–6 weeks. Full web or mobile applications run 10–16 weeks depending on scope. We give you a written timeline after the discovery call — no padded estimates.",
  },
  {
    q: "Do you work fixed-price or time & materials?",
    a: "Both. We default to fixed-scope sprints for predictability, then move to monthly retainers post-launch. Enterprise builds typically combine a fixed discovery phase with T&M delivery.",
  },
  {
    q: "What does a typical project cost?",
    a: "A polished marketing site starts around USD 4–8k. Web/mobile applications start around USD 15–40k depending on complexity. We share a detailed proposal after the first call.",
  },
  {
    q: "Who owns the code and the IP?",
    a: "You do. From day one — repos, designs, and documentation are transferred to your accounts. No vendor lock-in, no surprise licensing.",
  },
  {
    q: "Can you work with our existing team / tech stack?",
    a: "Yes. We routinely embed with in-house product and engineering teams, work alongside other vendors, and adapt to any modern stack (React, Next.js, Flutter, FastAPI, Node, .NET, etc.).",
  },
  {
    q: "What happens after launch?",
    a: "We offer monthly retainers covering bug fixes, security patches, performance monitoring, and continuous improvement. Most clients stay with us for years.",
  },
];
